import {useEffect, useState} from 'react';
import {useSession} from "../../../../../../firebase/UserProvider";

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function _authH() { const t = localStorage.getItem('access_token'); return t ? {'Authorization': `Bearer ${t}`} : {}; }

const useSubscribeToChatsList = () => {
    const {user} = useSession();
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid) { setLoading(false); return; }
        setLoading(true); setError(null);
        fetch(`${BASE}/api/chats/by-participant/${encodeURIComponent(user.uid)}`, {headers: _authH()})
            .then(r => r.ok ? r.json() : [])
            .then(data => { setChats(Array.isArray(data) ? data : []); setLoading(false); })
            .catch(err => { setError(err); setLoading(false); });
    }, [user?.uid]);

    const removeChat = (chatId) =>
        setChats(prev => prev.filter(c => c.id !== chatId));

    return {chats, loading, error, removeChat};
};

export default useSubscribeToChatsList;
